import { render } from "./referred-users-data-table.vue?vue&type=template&id=164c9732&ts=true"
import script from "./referred-users-data-table.vue?vue&type=script&lang=ts"
export * from "./referred-users-data-table.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__